import { useCallback, useEffect, useState } from "react";
import { Outlet, useLocation } from "react-router-dom";
import { alpha, Box, Toolbar, useMediaQuery, useTheme } from "@mui/material";
import Sidebar from "./Sidebar/Sidebar";
import { Navbar } from "./Navbar/Navbar";
import { getReportFilters } from "../../apis";

export const EGLayout = () => {
  const theme = useTheme();
  // Media query
  const isMobile = useMediaQuery(theme.breakpoints.down("md"));
  // Current rout
  const location = useLocation();
  // NOTE: The Analytics/Dashboard sidebar auto-hide behavior is disabled for
  // now. Keeping `isDashboard` forced to false so the sidebar always renders.
  // Re-enable by restoring the line below when the section is retaken.
  // const isDashboard = location.pathname === "/dashboard";
  const isDashboard = false;
  // Initial States
  // Custom report search filters
  const [savedFilters, setSavedFilters] = useState([]);

  // Sidebar actions
  const [sidebarOpen, setSidebarOpen] = useState(true);
  const [showSidebar, setShowSidebar] = useState(() => {
    return !isDashboard && !isMobile;
  });

  // Close/expanded sidebar
  const handleSidebarToggle = () => {
    setSidebarOpen((prev) => !prev);
  };

  useEffect(() => {
    // Mobile
    if (isMobile) {
      setSidebarOpen(true);
      setShowSidebar(false);
    } else {
      // Desktop
      if (isDashboard) {
        setSidebarOpen(false);
        setShowSidebar(false);
      } else {
        // Desktop & !isDashboard
        setShowSidebar(true);
      }
    }
  }, [location.pathname, isMobile]);

  // Reload changes made to filter settings
  const reloadSavedFilters = useCallback(async () => {
    try {
      const resp = await getReportFilters();
      setSavedFilters(resp.data);
    } catch (error) {
      console.error(error);
    }
  }, []);

  useEffect(() => {
    reloadSavedFilters();
  }, []);

  return (
    <Box sx={{ display: "flex" }}>
      {/* Navbar */}
      <Navbar
        isMobile={isMobile}
        isDashboard={isDashboard}
        showSidebar={showSidebar}
        setShowSidebar={setShowSidebar}
      />
      {/* Sidebar colapsable */}
      {showSidebar && (
        <Sidebar
          isMobile={isMobile}
          open={sidebarOpen}
          isDashboard={isDashboard}
          onToggleSidebar={handleSidebarToggle}
          setShowSidebar={setShowSidebar}
          customFilters={savedFilters}
        />
      )}
      {/* Main content */}
      <Box
        component="main"
        sx={{
          display: "flex",
          flexFlow: "column",
          minHeight: "100vh",
          flexGrow: 1,
          bgcolor: alpha(theme.palette.blueGray100.main, 0.6),
          p: { xs: 1, sm: 2 },
          borderTopLeftRadius: "16px",
          overflow: "hidden",
        }}
      >
        <Toolbar />
        <Outlet context={{ savedFilters, reloadSavedFilters }} />
      </Box>
    </Box>
  );
};
